import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a

      href='https://github.com/timone019/sam-folio'
      className='link footer__link'
    >
      © Copyright 2024
    </a>
  </footer>
)

export default Footer
